export const MAX_OVERDRAFT_LIMIT = 50000;

const TEST_PAYMENT_PATTERN =
  /^https:\/\/dashboard\.stripe\.com\/acct_[A-Za-z0-9]+\/test\/payments\/(pi|pr)_[A-Za-z0-9]+\/?$/;
const LIVE_PAYMENT_PATTERN =
  /^https:\/\/dashboard\.stripe\.com\/acct_[A-Za-z0-9]+\/payments\/(pi|pr)_[A-Za-z0-9]+\/?$/;

/** Stripe Customer page (test), with or without acct_ prefix */
const TEST_CUSTOMER_PATTERN =
  /^https:\/\/dashboard\.stripe\.com\/(?:acct_[A-Za-z0-9]+\/)?test\/customers\/cus_[A-Za-z0-9]+\/?$/;
/** Stripe Customer page (live), with or without acct_ prefix */
const LIVE_CUSTOMER_PATTERN =
  /^https:\/\/dashboard\.stripe\.com\/(?:acct_[A-Za-z0-9]+\/)?customers\/cus_[A-Za-z0-9]+\/?$/;

function stripQueryAndHash(url) {
  const q = url.indexOf('?');
  const h = url.indexOf('#');
  let end = url.length;
  if (q !== -1) end = Math.min(end, q);
  if (h !== -1) end = Math.min(end, h);
  return url.slice(0, end);
}

/**
 * Accepts Stripe Dashboard payment links (pi_/pr_) and Customer page URLs (cus_).
 */
export function validateStripePaymentLink(link) {
  const trimmed = typeof link === 'string' ? link.trim() : '';
  if (!trimmed) {
    return { valid: false, error: 'Stripe payment or customer link is required' };
  }
  const normalized = stripQueryAndHash(trimmed);
  if (
    TEST_PAYMENT_PATTERN.test(normalized) ||
    LIVE_PAYMENT_PATTERN.test(normalized) ||
    TEST_CUSTOMER_PATTERN.test(normalized) ||
    LIVE_CUSTOMER_PATTERN.test(normalized)
  ) {
    return { valid: true, url: normalized };
  }
  return {
    valid: false,
    error:
      'Enter a valid Stripe Dashboard payment link (pi_/pr_) or customer page URL (cus_)',
  };
}
